import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; // Utiliser useParams pour accéder aux paramètres de l'URL
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';
import { useSearchParams } from 'react-router-dom';
import countryList from 'country-list';

const UserProfile = () => {
const location = useLocation();
const navigate = useNavigate();
const { t } = useTranslation();
const fromDiscussionId = location.state?.fromDiscussion;

const [searchParams] = useSearchParams();
const fromComments = searchParams.get('from') === 'comments';



//  const handleBackToDiscussions = () => {
//    navigate(-1);
//  };

const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };

  const { id } = useParams(); // Récupérer l'ID du créateur à partir de l'URL
const [user, setUser] = useState(null);

  const [userData, setUserData] = useState(null);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  useEffect(() => {
    // Récupérer les données de l'utilisateur depuis l'API avec l'ID
    const fetchUserData = async () => {
      try {
const token = localStorage.getItem('token');  // Récupérer le token depuis localStorage

        if (!token) {
          console.error("Token non disponible");
          return;
        }

       const response = await api.get(`${API_URL}/api/UserProfile/${id}`, {
   headers: {
        'Authorization': `Bearer ${token}`  // Ajout du token dans l'en-tête
      },
});


        setUserData(response.data);

      } catch (error) {
if (error.response) {
    // La requête a été faite et le serveur a répondu avec un code d'état hors de la plage 2xx
    console.error('Erreur API:', error.response.data);
    console.error('Code d\'état:', error.response.status);
    console.error('Headers:', error.response.headers);
  } else if (error.request) {
    // La requête a été faite mais aucune réponse n'a été reçue
    console.error('Erreur de requête:', error.request);
  } else {
    // Quelque chose s'est passé en configurant la requête
    console.error('Erreur générale:', error.message);
  }
        console.error('Erreur lors de la récupération des données utilisateur', error);
      }
    };

    fetchUserData();
  }, [id]);


  if (!userData) {
    return <div>{t('userprofile.chargement')}</div>;
  }
const token = localStorage.getItem('token'); 

const birthDate = userData.birthDate
  ? new Date(userData.birthDate)
  : null;

const showFullBirthDate =
  userData.settings?.showBirthDate === true;

const showSimpleBirthDate =
  !showFullBirthDate &&
  userData.settings?.showBirthDateSimple === true;

const showAge =
  userData.settings?.showAge === true;

const showAnyBirthInfo =
  showFullBirthDate ||
  showSimpleBirthDate ||
  showAge;


const getCountryName = (code, lang) => {
  if (!code) return t('userprofile.empty');
  try {
    const regionNames = new Intl.DisplayNames([lang], { type: 'region' });
    return regionNames.of(code);
  } catch {
    return code; // fallback : affiche le code si langue non supportée
  }
};

const getFlagEmoji = (code) => {
  if (!code) return '';
  return code
    .toUpperCase()
    .split('')
    .map(char => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
};

const getLocalTime = (tz) => {
  if (!tz) return null;
  try {
    return new Intl.DateTimeFormat(i18n.language, {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(new Date());
  } catch {
    return null;
  }
};

const getUTCOffset = (tz) => {
  const offset = new Intl.DateTimeFormat('en', {
    timeZone: tz,
    timeZoneName: 'shortOffset',
  }).formatToParts(new Date()).find(p => p.type === 'timeZoneName')?.value || '';
  return offset.replace('GMT', '');
};
const calculateAge = (birthDate) => {
  if (!birthDate) return null;
  
  const today = new Date();
  const birth = new Date(birthDate);
  
  let age = today.getFullYear() - birth.getFullYear();
  
  // Ajustement si l'anniversaire n'est pas encore passé cette année
  const hasHadBirthdayThisYear =
    today.getMonth() > birth.getMonth() ||
    (today.getMonth() === birth.getMonth() && today.getDate() >= birth.getDate());
  
  if (!hasHadBirthdayThisYear) age--;
  
  return age;
};

const openExternalLink = (url) => {
  if (!url) return;
  if (window.cordova) {
    // _blank ouvre dans InAppBrowser (dans l'appli) avec bouton retour intégré
    cordova.InAppBrowser.open(url, '_blank', 'location=yes,closebuttoncaption=Retour,toolbar=yes');
  } else {
    window.open(url, '_blank');
  }
};
  return (
  <div className="user-profile-container">

    <div className="profile-card relative">

      <img 
        src={
          userData.profileImage
            ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${userData._id}?token=${token}&type=image&thumb=true&profile=true&t=${userData.profileImageUpdatedAt}`
            : `${API_URL}/uploads/default-profile.png`
        }
        alt="Image de profil"
        className="profile-image"
      />

      <h2 className="profile-username">{userData.username}</h2>

{userData.createdAt && (
  <p><strong>{t('userprofile.member_since')}</strong>
    {new Date(userData.createdAt).toLocaleDateString(i18n.language, {
      month: 'long', year: 'numeric',
    })}
  </p>
)}

      {!fromComments && userData.settings?.showEmail === true && (
        <p><strong>Email : </strong>
          <a href={`mailto:${userData.email}`}>{userData.email}</a>
        </p>
      )}

      <p><strong>{t('userprofile.firstname')}</strong>{userData.firstName || t('userprofile.empty')}</p>
      <p><strong>{t('userprofile.name')}</strong>{userData.lastName || t('userprofile.empty')}</p>

{/* Date de naissance */}
{birthDate && (showFullBirthDate || showSimpleBirthDate) && (
  <p>
    <strong>{t('profile.birthdate')}</strong>
    <br />

    {birthDate.toLocaleDateString(i18n.language, {
      day: 'numeric',
      month: 'long',
      ...(showFullBirthDate && { year: 'numeric' }),
    })}
  </p>
)}

{/* Âge */}
{showAge && userData.birthDate && (
  <p>
    <strong>{t('profile.age')}</strong><br />
    {calculateAge(userData.birthDate)} {t('profile.years')}
  </p>
)}

{/* Rien affiché */}
{birthDate && !showAnyBirthInfo && (
  <p>
    <strong>{t('profile.birthdate')}</strong><br />
    {t('userprofile.empty')}
  </p>
)}

      {!fromComments && userData.settings?.showPhone && (
        <p>
          <strong>{t('userprofile.phonenumber')}</strong>
          {userData.phoneNumber && userData.phoneNumber.trim() !== '' ? (
            <span className="phone-container">
              {userData.phoneNumber}
              <a onClick={() => window.open(`tel:${userData.phoneNumber}`, '_system')}>
                <img 
                  src={`${API_URL}/uploads/appel.png`} 
                  alt="Appeler" 
                  className="phone-icon"
                />
              </a>
            </span>
          ) : t('userprofile.empty')}
        </p>
      )}


<p>
  <strong>{t('profile.ville')} : </strong>
  <span style={{ textTransform: 'capitalize' }}>
    {userData.ville || t('userprofile.empty')}
  </span>
</p>

<p>
  <strong>{t('profile.pays')} : </strong>
  {userData.pays 
    ? `${getFlagEmoji(userData.pays)} ${getCountryName(userData.pays, i18n.language)}`
    : t('userprofile.empty')
  }
</p>

{userData.timezone && (
  <p><strong>{t('profile.timezone')}</strong>
    {`${userData.timezone} (UTC${getUTCOffset(userData.timezone)})`}
    {' — '}
    {t('profile.localtime')} : <strong>{getLocalTime(userData.timezone)}</strong>
  </p>
)}
     <p><strong>{t('profile.langue')} : </strong>{t(`languages.${userData.lang}`) || t('userprofile.empty')}</p>


<p><strong>{t('profile.bio')} : </strong>{userData.bio || t('userprofile.empty')}</p>
{(userData.facebook || userData.instagram || userData.linkedin || userData.website) && (
  <div>
    <strong>{t('profile.social')}</strong>
    <div style={{ display: 'flex', gap: '12px', marginTop: '6px' }}>

      {userData.facebook && (
        <span onClick={() => openExternalLink(userData.facebook)} style={{ cursor: 'pointer' }} title="Facebook">
          <img src={`${API_URL}/uploads/icon-facebook.png`} alt="Facebook" style={{ width: '24px' }} />
        </span>
      )}

      {userData.instagram && (
        <span onClick={() => openExternalLink(userData.instagram)} style={{ cursor: 'pointer' }} title="Instagram">
          <img src={`${API_URL}/uploads/icon-instagram.jpg`} alt="Instagram" style={{ width: '24px' }} />
        </span>
      )}

      {userData.linkedin && (
         <span onClick={() => openExternalLink(userData.linkedin)} style={{ cursor: 'pointer' }} title="LinkedIn">
          <img src={`${API_URL}/uploads/icon-linkedin.png`} alt="LinkedIn" style={{ width: '24px' }} />
        </span>
      )}

      {userData.website && (
        <span onClick={() => openExternalLink(userData.website)} style={{ cursor: 'pointer' }} title={t('profile.website')}>
          <img src={`${API_URL}/uploads/icon-website.png`} alt="Site web" style={{ width: '24px' }} />
        </span>
      )}

    </div>
  </div>
)}

     
    </div>
  </div>
);

};

export default UserProfile;

